import * as React from "react";
import { setTitle } from "../app/uiSlice";
import { useAppDispatch } from "./store";
import { isManage360 } from "../utils/helper";

const DEFAULT_TITLE = isManage360() ? "Manage360 Admin" : "Workz360 Admin";

export function useTitle(title: string, pageTitle?: string) {
  const dispatch = useAppDispatch();
  dispatch(setTitle(title));

  const _pageTitle = pageTitle || title;

  React.useEffect(() => {
    const prevTitle = document.title;
    document.title = !!_pageTitle
      ? `${_pageTitle} | ${DEFAULT_TITLE}`
      : DEFAULT_TITLE;
    return () => {
      document.title = prevTitle;
    };
  });
}
